
export default {
  name: 'MegasredaAuthorWidgetsArticleAuthor',
  props: {
    author: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      streamsVisibleCount: 3,
    }
  },
  computed: {
    streams() {
      const filteredStreams = this.author?.statistics?.forStreams.filter(
        (stream) => !!stream._id
      )
      return filteredStreams?.slice(0, this.streamsVisibleCount)
    },
    authorTitle() {
      if (this.author?.type === 'COMPANY') {
        return this.author?.company?.title
          ? this.author?.company?.title
          : this.author?.username
      } else {
        return this.author?.profile?.firstName && this.author?.profile?.lastName
          ? `${this.author?.profile.firstName} ${this.author?.profile.lastName}`
          : this.author?.username
      }
    },
    authorDescription() {
      if (this.author.type === 'COMPANY') {
        return this.author?.company?.description
      } else {
        return this.author?.profile?.description
      }
    },
    authorSite() {
      if (this.author.type === 'COMPANY') {
        return this.author?.company?.contacts?.website
      } else {
        return this.author?.profile?.contacts?.website
      }
    },
    actionButton() {
      if (this.author.type === 'COMPANY') {
        return this.author?.company?.actionButton
      } else {
        return this.author?.profile?.actionButton
      }
    },
    contacts() {
      return this.author.type === 'COMPANY'
        ? this.author?.company?.contacts
        : this.author?.profile?.contacts
    },
    isHasContacts() {
      return (
        this.contacts.youtube ||
        this.contacts.telegram ||
        this.contacts.vk ||
        this.contacts.ok ||
        this.contacts.yandexzen
      )
    },
    unsubscribeMessage() {
      if (this.author.type === 'COMPANY') {
        return `на компанию «${this.authorTitle}»`
      } else {
        return `на пользователя «${this.authorTitle}»`
      }
    },
  },
}
